import { Flex, Loader } from '@mantine/core';

export const TabLoader = () => {
  return (
    <Flex w="100%" justify="center" pt="3rem">
      <Loader />
    </Flex>
  );
};
